import { Player, PlayerRef } from "@remotion/player";
import React, { useCallback } from "react";

import {
  InnerVideoPreviewContainer,
  VideoContainer,
  VideoPreviewContainer,
} from "./styled";
import { CanvasComposition } from "../canvas/main";
import { useAppSelector } from "../../../../../redux/hooks";
import { useSettings } from "../context";
import { useTimelineContext } from "../remotion-timeline/context/use-timeline-context";

export const VideoPreview: React.FC<{
  playerRef: React.RefObject<PlayerRef>;
  loop: boolean;
}> = ({ playerRef, loop }) => {
  const { setSelectedItem, durationInFrames, tracks } = useTimelineContext();

  const { bottomPanelHeight } = useSettings();

  const video = useAppSelector((state) => state.transcript.data);

  const onPointerDownEmptySpace: React.MouseEventHandler<HTMLDivElement> =
    useCallback(() => {
      setSelectedItem(null);
    }, [setSelectedItem]);

  if (!video?.details) return;

  return (
    <VideoPreviewContainer bottomPanelHeight={bottomPanelHeight}>
      <InnerVideoPreviewContainer onPointerDown={onPointerDownEmptySpace}>
        <VideoContainer
          aspectRatio={video.details?.aspectRatio}
          bottomPanelHeight={bottomPanelHeight}
        >
          <Player
            ref={playerRef}
            alwaysShowControls
            component={CanvasComposition}
            durationInFrames={Math.floor(durationInFrames) + 1}
            outFrame={Math.max(1, Math.floor(durationInFrames) - 1)}
            compositionHeight={video.details?.height}
            compositionWidth={video.details?.width}
            fps={video.details?.fps}
            style={{ width: "100%", height: "100%" }}
            inputProps={{
              tracks,
              playerRef,
            }}
            loop={loop}
            browserMediaControlsBehavior={{ mode: "register-media-session" }}
            spaceKeyToPlayOrPause={false}
          />
        </VideoContainer>
      </InnerVideoPreviewContainer>
    </VideoPreviewContainer>
  );
};
